type SupportTokenPayload = {
  name?: string;
  preferred_username?: string;
  email?: string;
  sub?: string;
};

function decodeBase64Url(value: string): string {
  const normalized = value.replace(/-/g, "+").replace(/_/g, "/");
  const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, "=");
  return atob(padded);
}

export function getSupportUploadUsernameFromToken(token?: string): string {
  if (!token) return "";

  const parts = token.split(".");
  if (parts.length < 2) return "";

  try {
    const payload = JSON.parse(decodeBase64Url(parts[1])) as SupportTokenPayload;

    return (
      payload.name ||
      payload.preferred_username ||
      payload.email ||
      payload.sub ||
      ""
    );
  } catch {
    return "";
  }
}